import React from 'react';
import Dashboard    from '../pages/Dashboard';
import OrganiserDashboard    from '../pages/OrganiserDashboard';
import Users        from '../pages/Users';
import Farmers      from '../pages/Farmers';
import Organisers   from '../pages/Organisers';
import Villages     from '../pages/Villages';
import Materials    from '../pages/Materials';
import Ledger       from '../pages/Ledger';
import Accounts     from '../pages/Accounts';
import Distribution from '../pages/Distribution';
import Collection   from '../pages/Collection';
import Production   from '../pages/Production';
import Inventory    from '../pages/Inventory';
import Reports      from '../pages/Reports';
import Sales        from '../pages/Sales';
import Seasons      from '../pages/Seasons';
import Companies    from '../pages/Companies';

export default function PageRouter({ active, role }) {
   if (role === "Organiser" && active === "dashboard") {
      return <OrganiserDashboard />;
    }

  const pages = {
    dashboard: <Dashboard />,
    organiserDashboard: <OrganiserDashboard />,
    users: <Users />,
    farmers: <Farmers />,
    seasons: <Seasons />,
    organisers: <Organisers />,
    villages: <Villages />,
    materials: <Materials />,
    ledger: <Ledger />,
    accounts: <Accounts />,
    distribution: <Distribution />,
    collection: <Collection />,
    production: <Production />,
    inventory: <Inventory />,
    reports: <Reports />,
    sales: <Sales />,
    companies: <Companies />,
  };

  return pages[active] || (
    <div style={{ padding: 40, textAlign: 'center', color: 'var(--text-muted)' }}>
      <div style={{ fontSize: 48, marginBottom: 12 }}>🌾</div>
      <div>Page not found</div>
    </div>
  );
}
